import React from "react";
import { Typography, Box } from "@mui/material";
import UserList from "../components/UserList";

const ListUsers = () => {
  return (
    <Box sx={{ px: 5, pt: 2 }}>
      <Typography variant="h4">List Users</Typography>
      <UserList />
    </Box>
  );
};

export default ListUsers;
